
const adminRouter = [ 
   
]

export default adminRouter;


// WEBPACK FOOTER //
// ./src/router/adminRouter.js